function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".play-cls-1{isolation:isolate;}.play-cls-2{opacity:0.3;mix-blend-mode:overlay;}.play-cls-3{fill:#e20613;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "play-cls-1"
}, React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("image", {
  className: "play-cls-2",
  width: 37,
  height: 42,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAqCAYAAAA0yJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAADS0lEQVRYR82Y2XLbMAxFDx1nc6f9/+9sk3iN1QfymlcQaclJl2AGQ5mmpKMLEKSUhmHgq9lqbsD/sPXcgGgppeS/h78gdVpyzQhyzf4E5FWoAJNC6zaE9lNw3fAZUDKHeagBQKd/BK6pVAGaczfBnO34Angr2ESpBtCq4Q7lQPIR4K2qjaAaObQC7oJHMAd6N0/WDxkuLQFr5ZQrJJA1cF/ademLUO/AKbjDXVSbA+sluodqDTyYC+6ujB2oQMfih3Ku4FIZA8xPggtUJ5ek0APwVPyRCpaoUILZl//2pW9VWgjhpGNLwndPBnkCNsBzOb4vYwQloB2wLefuqWFOZNWggPVCuQRK4XsGvhXflD6dfyJD7YA3MrDyMZYRB2smf4Typ3KlFL4N8J0M9kwNoZTaUsOrmeoTwl2gi5XSxVypR6paP6hqrchPfSCrJAV9B+JF1Y8TDbXWQKxPMs0+gQlqQwb7TlbvjnyDAzXXfGZ6/VKZOFPzcaKWK+Wha+VVDKNyS9c4UJMf2mXiWPriqjCyaznlrqR1MKl2X8YcqQq1ZqPXN0E182pukye1YnX3gvpIBR/IcKpnrYIbgfKNLK/moNxiSB1UT7tuuK8OE5iW3QI1WBu91z+Z7p2+kc1BxRv4bkDrmhTwZFarxNbs83LQtQjVe2oHiWucFtojOaHfSrstY/ZlvJeDCdykTqmfcax1kqsiGM0mXWOgVvRfxV+L72iDdUO8hkxpBbSnUARSyFQEVdFfgJ/FX6hgCqmr1bReTrlK2pYIyJeWrR3r/1eqWi/UcGorc2KJUmatpPYdwAPjZcUXZBXK1+BvVKVa4ZtsX1pKxdApsXfUin2i7pmgVnBVb0925ZSr5Mk+sR6UqyQoFUntCFQYFeYDFUwumFgamrNOdoEqyQ61Or9T99l7DbPfXsldUXfBNGfd7B7drBU+zcxz+S2VNN7LhisTa9MlZNfeaJbMvkR+aoe89ooV902TYnnTK5aFEGodOTGG9MUVxjkouBbMIiC4rhSMC9yZ9krv4XbAm2Fk1z5wwBggwrRWgBEIHwCCDhRMwFqt29Bqb4WRzX7Ja3z06NnlQh+Fkc1CyTpvPBf7LIjbYqh/af7C+GXsS0L9BlRQNhTVg0q4AAAAAElFTkSuQmCC"
}), React.createElement("path", {
  className: "play-cls-3",
  d: "M10.2,18.81V11.22a1,1,0,0,1,1.58-.82L22.54,18a1,1,0,0,1,0,1.64l-10.76,7.6a1,1,0,0,1-1.58-.82Z"
}))));

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 37 42",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.adc9d0af.svg";
export { ForwardRef as ReactComponent };